module.exports = __webpack_public_path__ + "static/media/Icons_download_01.a2cdcc03.svg";